import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api.js";
import { logError } from "../lib/logger.js";

export interface LookupOption {
  value: string;
  displayName: string;
  rank: number;
}

type LookupMap = Record<string, LookupOption[]>;

interface LookupContextValue {
  map: LookupMap;
  refresh: () => void;
}

const LookupContext = createContext<LookupContextValue>({ map: {}, refresh: () => {} });

export function LookupProvider({ children }: { children: React.ReactNode }) {
  const [lookup, setLookup] = useState<LookupMap>({});

  const refresh = useCallback(() => {
    api.get<LookupMap>("/lookup").then(r => setLookup(r.data)).catch((err) => logError("LookupContext.load", err));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <LookupContext.Provider value={{ map: lookup, refresh }}>{children}</LookupContext.Provider>;
}

export function useLookup(category: string): LookupOption[] {
  return useContext(LookupContext).map[category] ?? [];
}

export function useLookupRefresh(): () => void {
  return useContext(LookupContext).refresh;
}
